import styled, { css } from 'styled-components'

export const PostContentText = styled.div`
  margin-bottom: ${({ theme }) => theme.rem(24)};
`
